import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationStateService, ThemeService } from 'Core/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  constructor(navigationStateService: NavigationStateService, themeService: ThemeService) {
    void navigationStateService;
    void themeService;
  }
}
